export default [
  {
    path: "/component-tests/vue-numeric-test",
    name: "vue-numeric-test",
    component: () => import("@/components/tests/VueNumericTest.vue"),
    meta: { requiresGuest: true },
  },
];
